const commentsData = [
  {
    name: '吃瓜一线猹',
    time: '2小时前',
    avatar: '瓜',
    content: '这个平台真的太全了！51吃瓜和91吃瓜的视频都能在这里找到，黑料吃瓜在线观看画质也很清晰，每天都要来刷一刷，吃瓜就认准这里了！',
    likes: '1.2k',
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    avatar: '圈',
    content: '作为老吃瓜人了，这个站更新是真的快。好多91在线吃瓜的内容其他平台还没有，这里就已经上线了，而且高清播放一点都不卡，强烈推荐！',
    likes: '986',
  },
  {
    name: '八卦小能手',
    time: '8小时前',
    avatar: '八',
    content: '之前一直到处找黑料吃瓜资源，现在有了这个站方便太多了。免费观看、即点即看，手机电脑都能看，吃瓜体验拉满，已经推荐给身边的瓜友了！',
    likes: '753',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-chat-3-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">瓜友热评</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">来自真实吃瓜群众的走心评价</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((item, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="font-bold text-primary-600 text-sm">{item.avatar}</span>
                </div>
                <div>
                  <div className="font-semibold text-foreground-900 text-sm">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}